import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Star1Icon } from '@blade/ui-kit'
import { DomUtil } from '@root/shared'
import { InfoMessage, type InfoIntent } from '@root/shared/ui-kit'

import DUMMY_BG from '../../assets/favorites-dummy.inline.svg'

type FavoritesTableEmptyProps = {
  onRetry: () => void
  intent: InfoIntent
}

export const FavoritesTableEmpty: React.FC<FavoritesTableEmptyProps> = ({
  onRetry,
  intent,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Message>
        {intent === 'empty' ? (
          <InfoMessage
            variant="bold"
            intent="empty"
            icon={<Star1Icon />}
            title={t('trading.favorites.empty-title')}
            description={t('trading.favorites.empty-description')}
            retryText={t('common.explore-tokens')}
            onRetry={onRetry}
            css={css`
              z-index: 1;
            `}
          />
        ) : (
          <InfoMessage
            variant="dt"
            intent="error"
            onRetry={onRetry}
            withSeparator
          />
        )}
      </Message>
    </Root>
  )
}

const Root = styled.div`
  background: ${DomUtil.cssUrl(DUMMY_BG)};

  display: grid;
  min-height: 100%;
  position: relative;
  background-repeat: repeat-y;
  background-size: contain;

  &::before {
    content: '';

    background: linear-gradient(0deg, var(--appearanceA-9) 0%, transparent 80%);

    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    width: 100%;
  }
`
const Message = styled.div`
  position: relative;
  place-self: center;
`
